/* ═══════════════════════════════════════
   THE BEAD COUNTER — THEME JS
═══════════════════════════════════════ */

/* ── HEADER SCROLLED STYLE ── */
(function() {
  var style = document.createElement('style');
  style.textContent = '.site-header.scrolled { box-shadow: 0 2px 16px rgba(13,34,55,0.08); }';
  document.head.appendChild(style);
})();

/* ── WAIT FOR DOM ── */
function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(function() {

  /* ── MOBILE NAV ── */
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  var overlay   = document.getElementById('page-overlay');
  var closeBtn  = document.getElementById('mobile-nav-close');
  var navIsOpen = false;

  function openNav() {
    navIsOpen = true;
    if (hamburger) { hamburger.classList.add('open'); hamburger.setAttribute('aria-expanded', 'true'); }
    if (mobileNav) { mobileNav.classList.add('open'); mobileNav.setAttribute('aria-hidden', 'false'); }
    if (overlay)   { overlay.classList.add('active'); }
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    navIsOpen = false;
    if (hamburger) { hamburger.classList.remove('open'); hamburger.setAttribute('aria-expanded', 'false'); }
    if (mobileNav) { mobileNav.classList.remove('open'); mobileNav.setAttribute('aria-hidden', 'true'); }
    if (overlay)   { overlay.classList.remove('active'); }
    document.body.style.overflow = '';
  }

  if (hamburger) {
    hamburger.addEventListener('click', function(e) {
      e.stopPropagation();
      navIsOpen ? closeNav() : openNav();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      closeNav();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeNav();
    });
  }

  if (mobileNav) {
    mobileNav.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && navIsOpen) closeNav();
  });

  /* ── MOBILE DROPDOWN ACCORDION ── */
  var navParents = document.querySelectorAll('.mobile-nav-parent');
  navParents.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var children = btn.nextElementSibling;
      var isOpen   = btn.classList.contains('open');
      navParents.forEach(function(b) {
        b.classList.remove('open');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
      });
      if (!isOpen && children) {
        btn.classList.add('open');
        children.classList.add('open');
      }
    });
  });

  /* ── SCROLL FADE-IN ── */
  var fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && window.IntersectionObserver) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function() {
            entry.target.classList.add('visible');
          }, i * 100);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(function(el) { io.observe(el); });
  }

  /* ── HEADER SCROLL SHADOW ── */
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ── AJAX CART ── */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function(res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return refreshCartCount().then(function() { return res.json(); });
    });
  }

  /* ── QUICK ADD ── */
  document.querySelectorAll('.quick-add-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn  = form.querySelector('.quick-add-btn');
      var id   = form.querySelector('[name="id"]').value;
      var orig = btn.innerHTML;

      if (!id) {
        console.error('No variant ID found');
        return;
      }

      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || 'Error adding to cart');
        }
        // Success
        btn.textContent = '✓ Added!';
        btn.style.background = 'var(--clay)';
        btn.disabled = false;
        showCartToast();
        // Update cart count
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        if (cart && cart.item_count !== undefined) {
          var badge = document.getElementById('cart-count');
          if (badge) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
        }
        setTimeout(function() { btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 2200);
      })
      .catch(function(err) {
        console.error('Quick add error:', err);
        // Item was likely added — just reset button
        btn.innerHTML = orig;
        btn.style.background = '';
        btn.disabled = false;
        showCartToast();
      });
    });
  });

  // Product page add-to-cart
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn      = document.getElementById('add-to-cart');
      var variantEl = document.getElementById('variant-id');
      var id       = variantEl ? variantEl.value : '';
      var qtyEl    = document.getElementById('qty-input');
      var qty      = parseInt(qtyEl ? qtyEl.value : 1) || 1;

      // Validate variant ID
      if (!id || id === '' || id === 'undefined') {
        alert('Please select all options before adding to cart.');
        return;
      }

      var orig = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: qty })
      })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(function(err) {
            throw new Error(err.description || 'Add to cart failed');
          });
        }
        return res.json();
      })
      .then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        // Update cart count
        var badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        btn.textContent = '✓ Added to Cart!';
        btn.style.background = 'var(--clay)';
        showCartToast();
        setTimeout(function() {
          btn.textContent = orig;
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        btn.textContent = orig;
        btn.disabled = false;
        alert(err.message || 'Sorry, something went wrong. Please try again.');
      });
    });
  }

  /* ── CART TOAST ── */
  function showCartToast() {
    var toast = document.getElementById('cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cart-toast';
      toast.style.cssText = [
        'position:fixed',
        'top:80px',
        'right:20px',
        'background:var(--ink)',
        'color:white',
        'padding:14px 20px',
        'font-size:13px',
        'letter-spacing:0.06em',
        'z-index:9999',
        'transform:translateX(120%)',
        'transition:transform 0.3s ease',
        'display:flex',
        'align-items:center',
        'gap:10px',
        'max-width:280px',
        'font-family:var(--ff-body)'
      ].join(';');
      toast.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Item added to cart';
      var link = document.createElement('a');
      link.href = '/cart';
      link.style.cssText = 'color:var(--clay);text-decoration:none;font-weight:500;border-bottom:1px solid var(--clay);margin-left:4px;';
      link.textContent = 'View Cart →';
      toast.appendChild(link);
      document.body.appendChild(toast);
    }
    requestAnimationFrame(function() { toast.style.transform = 'translateX(0)'; });
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function() { toast.style.transform = 'translateX(120%)'; }, 3500);
  }

  /* ── WISHLIST TOGGLE ── */
  document.querySelectorAll('.wishlist-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var svg   = btn.querySelector('svg');
      var saved = btn.getAttribute('data-saved') === 'true';
      btn.setAttribute('data-saved', String(!saved));
      if (svg) {
        svg.style.fill   = !saved ? 'var(--clay)' : 'none';
        svg.style.stroke = !saved ? 'var(--clay)' : 'var(--stone)';
      }
    });
  });

  /* ── SEARCH ── */
  var searchInput = document.querySelector('.search-input-wrap input[type="search"]');
  if (searchInput) {
    var searchTimer;
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function() {
        // predictive search placeholder
      }, 350);
    });
  }

  /* ── CART PAGE QUANTITY ── */
  document.querySelectorAll('.qty-btn[data-action]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var line    = parseInt(btn.dataset.line);
      var action  = btn.dataset.action;
      var display = btn.parentElement.querySelector('.qty-display');
      var qty     = parseInt(display.textContent);
      qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      display.textContent = qty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var sub = document.getElementById('cart-subtotal');
        if (sub) {
          sub.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        }
        if (qty === 0) {
          var item = btn.closest('.cart-item');
          if (item) item.remove();
        }
        var badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        if (cart.item_count === 0) location.reload();
      });
    });
  });

  document.querySelectorAll('.cart-remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var line = parseInt(btn.dataset.line);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function() { location.reload(); });
    });
  });

});